if (process.env.BUILD_GC === 'sesame' || process.env.BUILD_GC === 'cicp') {
  module.exports = require('./sesame')
} else {
  module.exports = null
}
